import React from "react"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import { createTheme } from "@material-ui/core"
import { ThemeProvider } from "@material-ui/styles"

import AuthenticationUtil from "../utils/AuthenticationUtil"
import { getUserCompanies } from "../utils/common"
import privateRoutes from "../routes/privateRoutes"
import PrivateLayout from "./Private"
import PublicLayout from "./Public"
import NotFound from "./NotFound"
import { APP_NAME, AUTH_URL } from "../../../constants"
import { deepOrange } from '@material-ui/core/colors';

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "'Open Sans', sans-serif",
    },
  },
  palette: {
    primary: {
      main: "#0071e3",
      contrastText: "#fff",
    },
    secondary: {
      main: deepOrange[800],
      contrastText: "#fff",
    }
  },
})

const MasterLayout = () => {
  const { location } = window
  const { isAuthenticated, getUser } = AuthenticationUtil

  const urlParams = new URLSearchParams(location.search)
  const accessTokenFromOmniAuth = urlParams.get("accessToken")
  const refreshTokenFromOmniAuth = urlParams.get("refreshToken")

  if (accessTokenFromOmniAuth && refreshTokenFromOmniAuth) {
    AuthenticationUtil.clearTokens()
    AuthenticationUtil.authenticateUser({
      accessToken: accessTokenFromOmniAuth,
      refreshToken: refreshTokenFromOmniAuth,
    })
  }

  const user = getUser()
  const userCompanies = getUserCompanies(user)

  if (user && userCompanies.length < 1) {
    return AuthenticationUtil.logout()
  }

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Switch>
          {privateRoutes.map(
            ({ component, path, parentComponent, isPlain }) => (
              <Route
                exact
                path={path}
                key={path}
                render={ route => {
                  const cbUrl = location.href
                  if (!isAuthenticated()) {
                    const url = `${AUTH_URL}/?cbUrl=${cbUrl}&appName=${APP_NAME}`
                    location.href = url
                    return true
                  }

                  return (
                    <PrivateLayout
                      Component={component}
                      ParentComponent={parentComponent}
                      route={route}
                      userCompanies={userCompanies}
                      isPlain={isPlain}
                    />
                  )
                }}
              />
            ),
          )}
          <Route
            render={ route => (
              <PublicLayout Component={NotFound} route={route} />
            )}
          />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default MasterLayout
